import { VariantType } from 'notistack';
import Library from 'commons/vo/Library';
import { SnackbarNotificationProps } from 'commons/vo/SnackbarNotification/type';

const messageFactory: { [key: string]: (id: number, contents: string) => Array<string> } = {
  SUCCESS: (id: number, contents) => [`${contents} (${id})`, '부분인출 작업이 완료되었습니다.'],
  FAILURE: (id: number, contents) => [`${contents} (${id})`, '부분인출 작업에 실패하였습니다.'],
};

const variants: { [key: string]: VariantType } = {
  SUCCESS: 'success',
  FAILURE: 'error',
};

class SnackbarNotification {
  library: Library;
  messages: Array<string>;
  options: { variant: VariantType };
  status: KeyFlowLibraryStatus;

  constructor(props: SnackbarNotificationProps) {
    const { library } = props;
    const { id, status, contents } = library;

    this.library = library;
    this.status = status as KeyFlowLibraryStatus;
    this.messages = messageFactory[status](id, contents);
    this.options = {
      variant: variants[status],
    };
  }

  get jobId() {
    return this.library.id;
  }
}

export default SnackbarNotification;
